import { useState } from "react";
import { AgentConsent } from "./AgentConsent";

interface AgentRoleConsentProps {
  name: string;
  pending: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/** The consent of adding an agent, asked again when its role goes from Viewer to Editor. */
export function AgentRoleConsent({ name, pending, error, onConfirm, onCancel }: AgentRoleConsentProps) {
  const [accepted, setAccepted] = useState(false);
  return (
    <AgentConsent
      name={name}
      role="editor"
      accepted={accepted}
      pending={pending}
      error={error}
      confirmLabel="agent.consent.changeRole"
      pendingLabel="agent.consent.changing"
      onAcceptedChange={setAccepted}
      onConfirm={onConfirm}
      onBack={onCancel}
    />
  );
}
